export default "__VITE_ASSET__BEnM95Pf__"